<small class="debug">{{me}}</small>




@if (fintechService.payerId != null) {
    <label class="header-label" style="user-select: text !important;">PayerId: {{fintechService.payerId}}</label>
<hr>
}
@else {
    <label class="header-label">Loading...</label>
}

@if (fintechService.data?.paymentInfo == null) {
    <app-fintech-recurring-status></app-fintech-recurring-status>
}

<app-fintech-contact></app-fintech-contact>
<hr>
<app-fintech-paymethod-editor setFintechMode="ACCOUNT"></app-fintech-paymethod-editor>
<app-fintech-payment-info></app-fintech-payment-info>


